import { Image } from "react-konva";
import useImage from "use-image";

export const ImageSrc = ({ src, width, height }) => {
  const [image] = useImage(src);
  return <Image width={width} height={height} image={image} />;
};
